export abstract class Constants {
  //Navigation tabs - project estimate elements
  public static ProjectElements = [
    {
      code: 'PRIN',
      routerLink: ['project-info'],
      textKey: 'navigation.projectInfo',
    },
    {
      code: 'DELI',
      routerLink: ['media-usage'],
      textKey: 'navigation.deliverables',
    },
    {
      code: 'TEAS',
      routerLink: ['team-assembly'],
      textKey: 'navigation.teamAndLogistics',
    },
    {
      code: 'BUDG',
      routerLink: ['budgeting'],
      textKey: 'navigation.budgeting',
    },
    {
      code: 'ESTM',
      routerLink: ['estimate'],
      textKey: 'navigation.estimateAndInvoice',
    },
    {
      code: 'PAYM',
      routerLink: ['payments'],
      textKey: 'navigation.payments',
    },
  ];
}
